import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;
const UserAdd = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    username: "",
    mobile_number: "",
    email: "",
    password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateClient = () => {
    let newErrors = {};

    if (!form.name.trim()) newErrors.name = "Full name is required";
    if (!form.username.trim()) newErrors.username = "Username is required";

    if (!form.mobile_number || !/^[0-9]{10}$/.test(form.mobile_number))
      newErrors.mobile_number = "Enter a valid 10-digit mobile number";

    if (form.email && !/\S+@\S+\.\S+/.test(form.email))
      newErrors.email = "Please enter a valid email";

    if (!form.password) newErrors.password = "Password is required";
    else if (form.password.length < 8) newErrors.password = "Minimum 8 characters";
    else if (!/[A-Z]/.test(form.password)) newErrors.password = "Must contain uppercase";
    else if (!/[0-9]/.test(form.password)) newErrors.password = "Must contain number";
    else if (!/[!@#$%^&*]/.test(form.password))
      newErrors.password = "Must contain special char";

    if (!form.confirm_password)
      newErrors.confirm_password = "Confirm password required";
    else if (form.confirm_password !== form.password)
      newErrors.confirm_password = "Passwords do not match";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGeneralError("");
    setErrors({});
    setSuccessMessage("");

    if (!validateClient()) return;

    try {
      const res = await fetch(`${API_URL}/api/users`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setGeneralError(data.detail || "Error occurred");
        return;
      }

      setSuccessMessage("User added successfully ✅");

      setForm({
        name: "", username: "", mobile_number: "", email: "",
        password: "", confirm_password: ""
      });

      setTimeout(() => navigate("/user-list"), 1400);
    } catch {
      setGeneralError("Server error");
    }
  };

  return (
    <div className="pt-6 pb-8 max-w-5xl mx-auto">   {/* Added top padding + wider max width */}

      {/* HEADER - Wider */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6">
        <h2 className="text-2xl font-semibold">Create New User</h2>
        <p className="text-sm opacity-90 mt-1">Fill the details below to register a new user</p>
      </div>

      {/* ERROR / SUCCESS */}
      {generalError && (
        <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl text-sm mb-6">
          {generalError}
        </div>
      )}

      {successMessage && (
        <div className="bg-green-50 border border-green-200 text-green-700 p-4 rounded-xl text-sm mb-6">
          {successMessage}
        </div>
      )}

      {/* FORM CARD - Wider */}
      <div className="bg-white rounded-2xl shadow p-8">   {/* Increased padding */}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

          <Input label="Full Name" name="name" value={form.name} onChange={handleChange} error={errors.name} />
          <Input label="Username" name="username" value={form.username} onChange={handleChange} error={errors.username} />
          <Input label="Mobile Number" name="mobile_number" value={form.mobile_number} onChange={handleChange} error={errors.mobile_number} />
          <Input label="Email (Optional)" name="email" value={form.email} onChange={handleChange} error={errors.email} />

          <Input label="Password" name="password" type="password" value={form.password} onChange={handleChange} error={errors.password} />
          <Input label="Confirm Password" name="confirm_password" type="password" value={form.confirm_password} onChange={handleChange} error={errors.confirm_password} />

          {/* PASSWORD NOTE */}
          <div className="md:col-span-2 text-xs text-gray-500 bg-blue-50 p-4 rounded-lg border">
            Password must contain 8+ characters, uppercase, number & special character.
          </div>

          {/* BUTTON */}
          <div className="md:col-span-2 flex justify-end pt-4">
            <button
              type="submit"
              className="px-12 py-3.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium shadow transition text-base"
            >
              Add User
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

const Input = ({
  label,
  name,
  value,
  onChange,
  error,
  type = "text",
}) => (
  <div className="space-y-1.5">
    <label className="text-sm font-medium text-gray-700 block">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className={`w-full px-4 py-3 rounded-xl border bg-gray-50 transition text-sm
        ${error ? "border-red-500" : "border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"}`}
    />
    {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
  </div>
);

export default UserAdd;